import { render, staticRenderFns } from "./IconCross.vue?vue&type=template&id=03ee9a2d&scoped=true&"
import script from "./IconCross.vue?vue&type=script&lang=js&"
export * from "./IconCross.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ee9a2d",
  null
  
)

export default component.exports